import { jsx as _jsx } from "react/jsx-runtime";
import { ThemeProvider } from '@view/providers/theme';
import { ROOT_CLASSNAME } from '@view/constants/root';
import { StyleCacheProvider } from '@view/providers/style-cache';
import { globalConfig } from '../helpers/global-config';
export const withChakraTheme = (Component) => {
    const ThemedComponent = (props) => (_jsx("div", { className: ROOT_CLASSNAME, children: _jsx(StyleCacheProvider, { children: _jsx(ThemeProvider, { colors: globalConfig.themeColors, isImmersiveExperience: true, children: _jsx(Component, Object.assign({}, props)) }) }) }));
    return ThemedComponent;
};
